import {gsap, SplitText} from "../LibrariesImport";
export default class RichText {
	static init() {

		this.editorImages = document.querySelectorAll('.rich-text img');
		this.editorImages.forEach((img) => {
			let link = img.closest('a');
			if (link && link.getAttribute('target') !== "_blank") {
				link.classList.add('image-pswp');
				link.setAttribute('data-pswp-src', img.src);
				link.setAttribute('data-pswp-width', img.getAttribute('width'));
				link.setAttribute('data-pswp-height', img.getAttribute('height'));
				link.setAttribute('data-pswp-alt', img.getAttribute('alt'));
			}
		});

		document.fonts.ready.then(() => {
			const blocks = document.querySelectorAll('.rich-text');
			blocks.forEach( (block) => {

				const texts = block.querySelectorAll('.text-highlight');
				texts.forEach( (text) => {
					const myText = new SplitText(text, {
						type: "words, chars"
					});

					gsap.fromTo(myText.chars,
						{
							opacity: 0,
							filter: 'blur(10px)'
						}, {
							opacity: 1,
							filter: 'blur(0px)',
							scrollTrigger: {
								trigger: block,
								start: "top 90%",
								end: "bottom center",
								scrub: true,
							},
							stagger: 0.02
						}
					);
				});

                const textsOnce = block.querySelectorAll('.text-highlight-once');
                textsOnce.forEach( (text) => {
                    const myText = new SplitText(text, {
                        type: "words, chars"
                    });

                    gsap.fromTo(myText.chars,
                        {
                            opacity: 0,
                            filter: 'blur(10px)'
                        }, {
                            opacity: 1,
                            filter: 'blur(0px)',
                            scrollTrigger: {
                                trigger: text,
                                start: "top bottom",
                                end: "top 60%",
                                duration: 1
                            },
                            stagger: 0.02
                        }
                    );
                });

			});
		});

	}
}